module.exports = __webpack_public_path__ + "img/ru.85c306dd.svg";